import { useEffect, useState } from "react";
import api from "../api";
import { Search } from 'lucide-react';
import Pagination from '../components/Pagination';

function ApprovalsList() {
  const [approvedExpenses, setApprovedExpenses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const itemsPerPage = 10;
  
  useEffect(() => {
    const fetchApprovedExpenses = async () => {
      try {
        const res = await api.get("/api/approvals/approved");
        setApprovedExpenses(res.data);
      } catch (error) {
        console.error("❌ Error fetching approved expenses:", error);
        alert("Failed to load approved expenses");
      }
    };
    fetchApprovedExpenses();
  }, []);

  const filteredExpenses = approvedExpenses.filter(exp => 
    (exp.expense_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    exp.expense_name?.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  
  const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);
  const currentItems = filteredExpenses.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  return (
    <div className="p-6 min-h-screen font-sans" style={{ color: 'var(--text)' }}>
        <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--text)' }}>Approved Expenses</h2>
        <div className="relative mb-6 w-full md:w-1/3">
          <Search className="absolute top-2.5 left-3" style={{ color: 'var(--muted)' }} />
          <input
            type="text"
            className="pl-10 pr-4 py-2 rounded-md w-full shadow-sm focus:outline-none"
            style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
            placeholder="Search expenses by ID or Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      <div className="rounded-xl shadow-sm border p-4" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
        {filteredExpenses.length === 0 ? (
          <p className="text-center py-8" style={{ color: 'var(--muted)' }}>No approved expenses found.</p>
        ) : (
          <>
            <div className="overflow-x-auto rounded-lg">
              <table className="min-w-full" style={{ color: 'var(--text)' }}>
                <thead className="border-b" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Creator User ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Expense ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Expense Name
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((exp) => (
                    <tr key={exp.expense_id} className="border-b" style={{ borderColor: 'var(--border)' }}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">{exp.creator_user_id}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>{exp.expense_id}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>{exp.expense_name}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>
                        {exp.date ? new Date(exp.date).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                          style={{ background: 'rgba(34,197,94,0.15)', color: '#16a34a' }}>
                          {exp.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="mt-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(p) => setCurrentPage(p)}
                totalItems={filteredExpenses.length}
                itemsPerPage={itemsPerPage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
  
export default ApprovalsList;

